import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SellerPercentageData} from '../../../../shared/models/seller-percentages.model';
import {PercentService} from '../../../../shared/services/percent/percent.service';
import {BankNameService} from '../../../../shared/services/bankName/bank-name.service';
import {roundIfMoreThan2Decimals} from "../../../../utils/roundIfMoreThan2Decimals.utils";


@Component({
  selector: 'app-seller-percent',
  templateUrl: './seller-percent.component.html',
  styleUrls: ['./seller-percent.component.scss']
})
export class SellerPercentComponent implements OnInit {
  @Input() sellersPercentage: SellerPercentageData;
  @Input() cnpjSeller: boolean = false;
  @Output() buttonStateChange = new EventEmitter<void>();

  constructor(private percentService: PercentService, private bankNameService: BankNameService) {
  }

  ngOnInit() {
    this.calculateTotalPercent();
  }

  changeNameSeller(seller: any) {
    switch (seller.type) {
      case 'ATTORNEY':
        return seller.name + ' (procurador)';
      case 'REPRESENTATIVE':
        return seller.name + ' (representante)';
      case 'PARTNER':
        return seller.name + ' (cônjuge ou companheiro)';
      default:
        return seller.name;
    }
  }

  calculateTotalPercent() {
    const totalSellers = roundIfMoreThan2Decimals(this.sellersPercentage?.accounts.reduce((sum, user) => sum + (user.percentage || 0), 0) || 0);

    const totalOtherSellers = roundIfMoreThan2Decimals(this.sellersPercentage?.otherSellers.reduce((sum, seller) => {
      let total: any = seller.percentage;
      if (seller.additional && seller.additional.length > 0) {
        total += seller.additional.reduce((acc, additional) => additional?.percentage ? acc + additional.percentage : 0, 0);
      }
      return sum + total;
    }, 0) || 0);

    this.percentService.updateTotalPercent(roundIfMoreThan2Decimals(totalSellers + totalOtherSellers));
  }

  onPercentInput(event: any, index: number): void {
    if (this.sellersPercentage?.accounts[index]) {
      let value = event.target.value.replace(',', '.');

      // Permite 0-100, até 2 casas decimais
      const regex = /^(100(\.0{0,2})?|(\d{0,2}(\.\d{0,2})?))$/;

      if (value === '') {
        // Se o campo está vazio, atribui null
        this.sellersPercentage.accounts[index].percentage = null;
        event.target.value = '';
      } else if (regex.test(value)) {
        // Limita o valor entre 0 e 100
        let num = parseFloat(value);
        if (!isNaN(num)) {
          if (num > 100) num = 100;
          if (num < 0) num = 0;
          // Arredonda para 2 casas
          num = roundIfMoreThan2Decimals(num);
          this.sellersPercentage.accounts[index].percentage = num;
        } else {
          // Se não for número válido, seta null
          this.sellersPercentage.accounts[index].percentage = null;
        }
      } else {
        // Remove último caractere inválido
        value = value.slice(0, -1);
        event.target.value = value;
        this.sellersPercentage.accounts[index].percentage = value ? Number(value) : null;
      }

      this.calculateTotalPercent();
      this.buttonStateChange.emit();
    } else {
      console.error('Usuário não encontrado no índice:', index);
    }
  }

  getBankNameFromBackend(bankNumber: string) {
    return this.bankNameService.getBankName(bankNumber);
  }

}
